import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import { rejectTrip } from "../Home/homeActions";
import Modal from "../../Components/Modal";
import headerImage from "../../assets/generic_transport.png";
import { updateClubbedTripStatus } from "../Transports/action";
import RejectionReason from "./RejectionReason";
import { TRIP_STATUS } from "../../helpers/constants";
import SwipeButton from "../../Components/SwipeButton";
import SwipeButtonRTL from "../../Components/SwipeButtonRTL";
import { shifterTripSeenUpdate } from "../../services/api/shifterSeenUpdate";

const GenericTrip = ({ tripDetails }) => {
  const {
    rejection_reasons_generic: rejectionReason = [],
    allow_trip_rejection: rejectionEnabled = true,
    trip_seen: tripSeen,
  } = useSelector((state) => state.login.user);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isReject, toggleReject] = useState(false);
  const [isAccept, toggleAccept] = useState(false);
  const [isReason, toggleReason] = useState(false);

  const { shifter_type: shifterType, trip_number: tripNumber } = tripDetails;

  useEffect(() => {
    if (!tripSeen) {
      dispatch(shifterTripSeenUpdate("seen"));
    }
  }, []);

  const handleReject = () => {
    if (rejectionReason?.length > 0) {
      toggleReason(true);
      toggleReject(true);
    } else {
      toggleReject(true);
      dispatch(rejectTrip(tripDetails?.id, "", () => toggleReject(false)));
    }
  };

  return (
    <div className={styles.trip_assigned}>
      <Modal fullModal>
        <div className={styles["clubbed-trip"]}>
          <h2 className={styles["clubbed-trip__heading"]}>
            {t("Trip Assigned")}
          </h2>
          <img
            src={headerImage}
            alt="Generic Transport"
            className={styles["clubbed-trip__image"]}
          />
          <div className={styles["clubbed-trip__data"]}>
            <label>{`${t("Trip ID")} : ${tripNumber}`}</label>
            <label>{`${t("Mode")} : ${
              shifterType === "primary" ? t("Main") : t("Support")
            }`}</label>
          </div>

          <SwipeButton
            onComplete={() => {
              toggleAccept(true);
              dispatch(
                updateClubbedTripStatus(
                  tripDetails?.id,
                  TRIP_STATUS.SHIFTER_ACCEPTED,
                  {},
                  () => toggleAccept(false)
                )
              );
            }}
            loader={isAccept}
            label={t("Accept")}
          />

          {rejectionEnabled && (
            <SwipeButtonRTL
              onComplete={handleReject}
              loader={isReject}
              label={t("Reject")}
            />
          )}
        </div>
      </Modal>
      {isReason && (
        <Modal
          bottomModal
          onCancel={() => {
            toggleReason(false);
            toggleReject(false);
          }}
        >
          <RejectionReason
            reasons={rejectionReason}
            tripId={tripDetails?.id}
            onClose={() => {
              toggleReason(false);
              toggleReject(false);
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default GenericTrip;
